import { Injectable, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';

/** Same cut-off the rest of the app's stylesheets use for "mobile". */
@Injectable({ providedIn: 'root' })
export class Viewport {
  private breakpoints = inject(BreakpointObserver);

  readonly isMobile$ = this.breakpoints
    .observe('(max-width: 768px)')
    .pipe(map(state => state.matches), shareReplay({ bufferSize: 1, refCount: true }));
}
